import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileFolderPopUpComponent } from '../components/upload-file-folder-pop-up/upload-file-folder-pop-up.component';
import { UploadDialogData } from '../model/upload-file-folder-interface';
import { InfoWarnError } from '../model/upload-file-folder-interface';
import { InfoWarnErrorDialogComponent } from '../components/common-dialog/info-warn-error-dialog/info-warn-error-dialog.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private _dialog: MatDialog) {}

  /**
   * Method helps the open the upload popup in screen
   *
   * @param {UploadDialogData} dialogData
   * @return {*}
   * @memberof DialogService
   */
  public uploadDataPopUp(dialogData: UploadDialogData) {
    return this._dialog.open(UploadFileFolderPopUpComponent, {
      minWidth: '45.5rem',
      data: dialogData,
      disableClose: true,
    });
  }

  /**
   * Opens a common dialog with the provided data for type "info", "warning", "error".
   *
   * @param {InfoWarnError} data
   * @return {*}  {Observable<boolean>}
   * @memberof DialogService
   */
  public commonDialog(data: InfoWarnError): Observable<boolean> {
    const dialogRef = this._dialog.open(InfoWarnErrorDialogComponent, {
      width: '39.5rem',
      data: data,
      disableClose: true,
    });
    return dialogRef.afterClosed() as Observable<boolean>;
  }
}
